import {
  DECREMENT_LIMIT,
  DecrementLimitAction,
  UPDATE_LIMITS,
  UpdateLimitsAction
} from 'js/actionCreators/limitActions';
import { Limits } from 'js/types';
import { LIMITS } from 'js/config/consts';
const initialState: Limits = {
  [LIMITS.DOWNLOADS]: {
    count: 0,
    resetDate: '',
    limit: 0,
    limitUpgrades: [],
    units: 'count'
  },
  [LIMITS.IMAGE_GENERATIONS]: {
    count: 0,
    resetDate: '',
    limit: 0,
    limitUpgrades: [],
    units: 'count'
  },
  [LIMITS.VOICEOVER_GENERATION]: {
    count: 0,
    resetDate: '',
    limit: 0,
    limitUpgrades: [],
    units: 'seconds'
  },
  [LIMITS.SCRIPT_GENERATION]: {
    count: 0,
    resetDate: '',
    limit: 0,
    limitUpgrades: [],
    units: 'seconds'
  }
};

type LimitActions = UpdateLimitsAction | DecrementLimitAction;

export default function limitReducer(state = initialState, action: LimitActions): Limits {
  switch (action.type) {
    case UPDATE_LIMITS:
      return { ...state, ...action.limits };
    case DECREMENT_LIMIT:
      return {
        ...state,
        [action.limitType]: {
          ...state[action.limitType],
          count: state[action.limitType].count + action.decrementAmount
        }
      };
    default:
      return state;
  }
}
